import Game from "../../../../src/Game";
import PointManager from "./PointManager/PointManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager/AngleManager";
import PointTagManager from "./PointTagManager";
import SliderManager from "./SliderManager";
import TangentRatioButtonManager from "./TangentRatioButtonManager";
import IntroAnimationManager from "./IntroAnimationManager/IntroAnimationManager";
import Circle from "../../../../src/entities/Circle";
import InfoSlider from "../../../../src/entities/InfoSlider/InfoSlider";
import Quasimodo from "../entities/Quasimodo";
import GenRanTriangleButton from "../entities/GenRandomTriangle";
import QuasimodoModeSwitcherCon from "../entities/QuasimodoModeSwitcherCon";
import { EventBus, EnumEventBus } from "./EventBus";
import { RootEventBus, EnumRootEventBus } from "../../../../src/managers/RootEventBus";
import { getCircleDetails } from "../helpers/getCircleDetails";
import { BLUE_ANGLE_COLORS, CENTER_OF_CIRCLE, CIRCLE_COLORS, INFO_SLIDER_ASSETS, INFO_SLIDER_COORD, INITIAL_TRIANGLE_RADIANS, PINK_ANGLE_COLORS } from "../types/Config";
import generatePoints from "../../../../src/utils/generatePoints";
import isCircumPointBetween from "../../../../src/utils/isCircumPointBetween";
import GuideText from "../../../../src/entities/GuideText";
import GuideTextTangent from "../entities/GuideTextTangent";
import getCircleColors from "../helpers/getCircleColors";


export default class ComponentManager {
  Game = Game.getInstance();
  RootEventBus = RootEventBus;
  EventBus = EventBus;
  completedIntroAnim = false;
  cCoord = this.isPortail();
  circle = new Circle(this.cCoord, INITIAL_TRIANGLE_RADIANS, CIRCLE_COLORS);
  PointManager = new PointManager(this.cCoord);
  PointTagManager = new PointTagManager(this.cCoord);
  TangentRatioButtonManager = new TangentRatioButtonManager();
  AngleManager = new AngleManager();
  LineManager = new LineManager([BLUE_ANGLE_COLORS[1], PINK_ANGLE_COLORS[1]]);
  SliderManager = new SliderManager();
  Quasimodo = new Quasimodo(this.cCoord);
  InfoSlider = new InfoSlider(INFO_SLIDER_COORD, INFO_SLIDER_ASSETS)
  genRandomTriangle = new GenRanTriangleButton();
  QuasimodoMode: boolean = false;
  QuasimodoSwitcherModeCon = new QuasimodoModeSwitcherCon();
  GuideText = new GuideText({ x: 100, y: 10 });
  GuideTextTangent = new GuideTextTangent()
  IntroAnimationManager = new IntroAnimationManager(
    this.PointManager,
    this.PointTagManager,
    this.AngleManager,
    this.LineManager,
    this.TangentRatioButtonManager,
    this.SliderManager,
    this.circle,
    this.cCoord
  );

  constructor() {
    this.genRandomTriangle.setVisible(false);
    this.IntroAnimationManager.runAnimations();

    this.RootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
    this.EventBus.on(EnumEventBus.quasimodoMode, (v: boolean) => this.setQuasimodoMode(v));
    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.completedIntroAnim = true);
  }

  isPortail() {
    const dim = this.Game.getDim();
    if (dim.WIDTH > dim.HEIGHT) {
      return CENTER_OF_CIRCLE
    }
    return {
      x: dim.WIDTH / 2,
      y: dim.HEIGHT / 2
    }
  }
  setQuasimodoMode(v: boolean) {
    this.QuasimodoMode = v;
    [this.PointTagManager, this.TangentRatioButtonManager].forEach(m => m.setAllVisible(!v));
    [this.GuideText, this.GuideTextTangent].forEach(t => t.setVisible(!v));
    this.Quasimodo.setVisible(v);
    this.drawElements();
  }
  drawElements() {
    const points = this.PointManager.getPoints();
    const radians = this.PointManager.getRadians();

    const isbtw = isCircumPointBetween(points[0], points[3], radians[0], radians[1]);
    const radius = this.PointManager.circleRadius;
    const sltdTPIndex = this.PointManager.getSltdTPointIndex();
    const redPointsCoord = this.PointManager.getRedPointsCoord();
    const tangentCoords = this.PointManager.getTangentCoords();
    const circleDetails = getCircleDetails(sltdTPIndex, radians, radius, isbtw);

    this.completedIntroAnim && this.circle.setColors(getCircleColors(CIRCLE_COLORS, isbtw, this.QuasimodoMode));

    this.circle.draw(circleDetails);
    this.LineManager.draw(redPointsCoord, tangentCoords, sltdTPIndex);
    this.AngleManager.draw(redPointsCoord, tangentCoords, sltdTPIndex, !isbtw);
    if (this.QuasimodoMode) {
      this.Quasimodo.updateCoord(sltdTPIndex, radians, radius, isbtw);
    } else {
      this.PointTagManager.updateCoord(radians, radius);
      this.TangentRatioButtonManager.draw(generatePoints(this.cCoord, radians, radius + 70), sltdTPIndex);
    }
  }
}